import { HealthRepository } from "../repositories/Health.repository";

export const HealthService = {
    getCodeHealth,
}

async function getCodeHealth(){
    const res = await HealthRepository.getCodeHealth();
    return res;
}